import { createFileRoute } from '@tanstack/react-router'
import { StoreDashboardPage } from '~/components/routes/store-dashboard/page/store-dashboard-page'
import { withRoutePermissions } from '~/utils/rbac'
import { storeDashboardSearchSchema } from './-search-schema'

function StoreDashboardRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return <StoreDashboardPage search={search} navigate={navigate} />
}

export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: StoreDashboardRoute,
  staticData: { permission: ['read', 'dashboard.dashboard.global-indicators'] },
  validateSearch: storeDashboardSearchSchema,
})

withRoutePermissions(Route)
